import React from 'react';

import { dashboardConfig } from 'config/routeConfigurations/dashboardConfig/dashboardConfig';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import useUserHook from 'hooks/useUserHook';

import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';
import GuardedRoute from 'components/common/GuardedRoute/guardedRoute';
import NoAccess from 'components/common/NoAccess/noAccess';

import { reportingConfig } from 'components/Dashboards/Reporting/reportingConfig';
import { Responsive } from 'components/Dashboards/responsive';
import { ConfirmWidgetPage } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPage';
import { ConfirmWidgetPageWrapper } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPageWrapper';
import { CreateReportPage } from 'components/pages/CreateReportPage/CreateReportPage';
import { ReportPage } from 'components/pages/ReportPage/ReportPage';
import { ReportingHomePage } from 'components/pages/ReportingHomePage/ReportingHomePage';

const ReportingRoutes = () => {
    const { path } = useRouteMatch();
    const { ability } = useUserHook();
    const isReportingAbility = ability.can('view', 'ReportsView');

    return (
        <Responsive title={dashboardConfig.reporting.title} isReporting={true}>
            <Switch>
                {/* Reports home page */}
                <GuardedRoute
                    exact
                    path={path}
                    component={ReportingHomePage}
                    auth={isReportingAbility}
                    redirect={`${path}/no-access`}
                />
                {/* Report creation flow */}
                <GuardedRoute
                    path={`${path}/${reportingConfig.create.link}`}
                    component={CreateReportPage}
                    auth={isReportingAbility}
                    redirect={`${path}/no-access`}
                />
                {/* Add new widget to report */}
                <GuardedRoute
                    path={`${path}/:reportId([0-9-]+)/${reportingConfig.confirmWidget.link}/:componentKey`}
                    component={ConfirmWidgetPage}
                    auth={isReportingAbility}
                    redirect={`${path}/no-access`}
                />
                {/* Edit widget inside saved report */}
                <GuardedRoute
                    path={`${path}/:reportId([0-9-]+)/${reportingConfig.editWidget.link}/:widgetId([0-9-]+)`}
                    component={ConfirmWidgetPageWrapper}
                    auth={isReportingAbility}
                    redirect={`${path}/no-access`}
                />
                {/* Current selected report view */}
                <GuardedRoute
                    path={`${path}/:reportId([0-9-]+)`}
                    component={ReportPage}
                    auth={isReportingAbility}
                    redirect={`${path}/no-access`}
                />

                <Route exact path={`${path}/no-access`} component={NoAccess} />
                <Route path={'*'} component={PageNotFound} />
            </Switch>
        </Responsive>
    );
};
export default ReportingRoutes;
